// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H2V2H22V22ZM4 20H7V7H20V4H4V20ZM10 14V16H16V14H10ZM10 10V12H18V10H10Z"}}]};

const PageIncludedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'page-included-filled',
    ref,
    icon: element,
  },
));

PageIncludedFilledIcon.displayName = 'PageIncludedFilledIcon';

export default PageIncludedFilledIcon;
